import React, { useEffect, useState } from "react";

const FORM = [
  ["Prénom", "Camille"],
  ["Nom", "RIVIÈRE"],
  ["Téléphone", "06 •• •• •• 42"],
  ["Motif", "Adaptation de lentilles"],
  ["Message", "Bonjour, mon ordonnance est-elle encore valable ?"],
  ["Consentement", "Oui"],
];

const STEPS = [
  {
    el: "dpr-form",
    t: "1. Son rendez-vous crée sa fiche",
    d: "Il la remplit lui-même : contact, motif, consentement. Vous n'avez rien à ressaisir au comptoir.",
  },
  {
    el: "dpr-docs",
    t: "2. Il prépare son rendez-vous",
    d: "Son ordonnance arrive dans le rendez-vous. Pas en pièce jointe sur une boîte Gmail.",
  },
  {
    el: "dpr-mail",
    t: "3. Vous vérifiez avant son passage",
    d: "Un oubli ? Vous lui demandez la pièce manquante depuis le rendez-vous, pas depuis votre adresse personnelle.",
  },
  {
    el: "dpr-hist",
    t: "4. Tout reste attaché au rendez-vous",
    d: "Le document arrive, l'échange est horodaté, au même endroit. Personne ne cherche dans ses mails.",
  },
];

export default function DossierPret() {
  const [i, setI] = useState(0);

  useEffect(() => {
    const m = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)");
    if (m && m.matches) return undefined;
    const id = setInterval(() => setI((v) => (v + 1) % STEPS.length), 3400);
    return () => clearInterval(id);
  }, []);

  const spot = (n) => (STEPS[i].el === n ? " dpr-spot" : "");
  const ecrit = i >= 2;
  const recu = i >= 3;

  return (
    <div className="dpr">
      <style>{PCSS}</style>

      <div className="dpr-app">
        <div className="dpr-main">
          <div className="dpr-top">
            <h3>Adaptation de lentilles</h3>
            <span className="dpr-badge">Confirmé</span>
            <span className="dpr-when">Jeudi 11 septembre · 12:54 · 45 min</span>
          </div>

          <div className={"dpr-form" + spot("dpr-form")}>
            <div className="dpr-lab">Préparation du rendez-vous</div>
            <table className="dpr-tab">
              <tbody>
                {FORM.map(([k, v]) => (
                  <tr key={k}>
                    <th>{k}</th>
                    <td>{v}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          <div className={"dpr-docs" + spot("dpr-docs")}>
            <div className="dpr-lab">Documents du patient</div>

            <div className="dpr-doc">
              <span className="dpr-ic dpr-pdf">PDF</span>
              <span className="dpr-bd">
                <span className="dpr-ti">Ordonnance</span>
                <span className="dpr-me">70 Ko · déposé par la patiente · reçu hier 10:55</span>
              </span>
              <span className="dpr-dl">Télécharger</span>
            </div>

            {recu ? (
              <div className="dpr-doc dpr-new">
                <span className="dpr-ic dpr-img">JPG</span>
                <span className="dpr-bd">
                  <span className="dpr-ti">
                    <span className="dpr-tag">Nouveau</span>
                    Carte de mutuelle
                  </span>
                  <span className="dpr-me">340 Ko · déposé par la patiente · à l'instant</span>
                </span>
                <span className="dpr-dl">Télécharger</span>
              </div>
            ) : (
              <div className="dpr-empty">Attestation de Sécurité sociale · carte de mutuelle</div>
            )}
          </div>

          <div className={"dpr-hist" + spot("dpr-hist")}>
            <div className="dpr-lab">Historique</div>
            <ul className="dpr-tl">
              {recu ? (
                <li>
                  <i className="dpr-dotb" />
                  <b>Document reçu</b> — carte de mutuelle <em>à l'instant</em>
                </li>
              ) : null}
              {ecrit ? (
                <li>
                  <i className="dpr-dotb" />
                  <b>Message envoyé</b> — par Claire FONTAINE <em>à l'instant</em>
                </li>
              ) : null}
              <li>
                <i className="dpr-dotg" />
                <b>Rendez-vous créé</b> — depuis la page de l'établissement <em>hier 10:55</em>
              </li>
            </ul>
          </div>
        </div>

        <aside className="dpr-side">
          <div className="dpr-lab">Actions rapides</div>
          <button type="button" className="dpr-b2">Modifier</button>
          <button type="button" className="dpr-b2">Renvoyer la notification</button>
          <button type="button" className={"dpr-mail" + spot("dpr-mail")}>
            <svg viewBox="0 0 24 24" aria-hidden="true">
              <rect x="3" y="5" width="18" height="14" rx="2" fill="none" stroke="currentColor" strokeWidth="2" />
              <path d="m3.5 6.5 8.5 6 8.5-6" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
            </svg>
            Écrire au patient
          </button>

          {ecrit ? (
            <div className="dpr-compo">
              <div className="dpr-clab">Message au patient</div>
              <div className="dpr-ctxt">
                Bonjour, il me manque votre carte de mutuelle. Vous pouvez la déposer ici.
              </div>
              <div className="dpr-cact">
                <span className="dpr-cannul">Annuler</span>
                <span className="dpr-cenv">Envoyer</span>
              </div>
            </div>
          ) : null}

          <div className="dpr-canal">
            <b>Un seul canal</b>
            Le patient reçoit et répond depuis son espace. Rien ne transite par une boîte grand
            public.
          </div>
        </aside>
      </div>

      <div className="dpr-dots">
        {STEPS.map((s, n) => (
          <button
            key={s.t}
            type="button"
            aria-label={s.t}
            className={"dpr-dot" + (n === i ? " dpr-doton" : "")}
            onClick={() => setI(n)}
          />
        ))}
      </div>

      <ol className="dpr-caps">
        {STEPS.map((s, n) => (
          <li className={"dpr-cap" + (n === i ? " dpr-capon" : "")} key={s.t}>
            <b>{s.t}</b>
            <p>{s.d}</p>
          </li>
        ))}
      </ol>
    </div>
  );
}

const PCSS = `
.dpr{margin-top:30px}
.dpr *{box-sizing:border-box}
.dpr-app{background:#fff;border:1px solid #D8DCE2;border-radius:16px;overflow:hidden;
  box-shadow:0 26px 60px -34px rgba(15,23,42,.45);max-width:940px;margin:0 auto;display:flex}
.dpr-main{flex:1;min-width:0;padding:16px 16px 18px;display:grid;gap:12px;align-content:start}
.dpr-top{display:flex;align-items:center;gap:10px;flex-wrap:wrap}
.dpr .dpr-top h3{font-size:16px;margin:0;color:#0F172A;font-weight:600}
.dpr-badge{font-size:10.4px;font-weight:700;letter-spacing:.04em;text-transform:uppercase;
  background:#E8F7EE;color:#14532D;border:1px solid #A8DCBE;border-radius:999px;padding:3px 9px}
.dpr-when{margin-left:auto;font-size:11.6px;color:#8A93A5}

.dpr-form,.dpr-docs,.dpr-hist{border:1px solid #E6E8EC;border-radius:12px;background:#fff;
  padding:13px 14px;transition:box-shadow .2s,border-color .2s}
.dpr-lab{font-size:9.6px;font-weight:700;letter-spacing:.09em;text-transform:uppercase;color:#8A93A5}
.dpr-tab{width:100%;border-collapse:collapse;margin-top:8px}
.dpr-tab th,.dpr-tab td{text-align:left;font-size:12.4px;padding:6px 0;border-bottom:1px solid #F1F3F6;
  vertical-align:top}
.dpr-tab tr:last-child th,.dpr-tab tr:last-child td{border-bottom:0}
.dpr-tab th{width:104px;color:#8A93A5;font-weight:600}
.dpr-tab td{color:#25304A}

.dpr-doc{display:grid;grid-template-columns:38px 1fr auto;gap:11px;align-items:center;
  margin-top:9px;padding:9px 10px;border:1px solid #E6E8EC;border-radius:10px;background:#FAFBFC}
.dpr-ic{width:38px;height:38px;border-radius:9px;display:grid;place-items:center;font-size:10px;
  font-weight:700;color:#fff;letter-spacing:.03em}
.dpr-pdf{background:#D64545}
.dpr-img{background:#2F80ED}
.dpr-bd{min-width:0}
.dpr-ti{display:block;font-size:12.8px;font-weight:600;color:#0F172A;line-height:1.35}
.dpr-me{display:block;font-size:10.8px;color:#8A93A5;margin-top:2px}
.dpr-dl{font-size:11.6px;font-weight:600;color:#0080FF;white-space:nowrap}
.dpr-empty{margin-top:9px;padding:11px 12px;border:1px dashed #DDE1E8;border-radius:10px;
  font-size:11.6px;color:#A2AAB8}
.dpr-new{background:#F2FBF5;border-color:#A8DCBE;animation:dpr-in .38s ease both}
@keyframes dpr-in{from{opacity:0;transform:translateY(-6px)}to{opacity:1;transform:none}}
.dpr-tag{display:inline-block;font-size:9.4px;font-weight:700;letter-spacing:.04em;
  text-transform:uppercase;background:#E8F7EE;color:#14532D;border:1px solid #A8DCBE;
  border-radius:999px;padding:2px 7px;margin-right:6px;vertical-align:1px}

.dpr-tl{list-style:none;margin:8px 0 0;padding:0;display:grid;gap:7px}
.dpr-tl li{display:flex;align-items:baseline;gap:8px;font-size:11.8px;color:#5A6478;line-height:1.45}
.dpr-tl b{color:#0F172A;font-weight:600}
.dpr-tl em{font-style:normal;color:#A2AAB8;margin-left:auto;white-space:nowrap}
.dpr-tl i{width:7px;height:7px;border-radius:999px;flex:0 0 7px;position:relative;top:-1px}
.dpr-dotb{background:#0080FF}
.dpr-dotg{background:#C3CAD6}

.dpr-side{width:274px;flex:0 0 274px;border-left:1px solid #E6E8EC;background:#FAFBFC;
  padding:16px 15px;display:grid;gap:9px;align-content:start}
.dpr-b2{font:inherit;font-size:12.2px;font-weight:600;color:#3D4759;background:#fff;
  border:1px solid #E6E8EC;border-radius:9px;padding:9px 12px;cursor:pointer;text-align:center}
.dpr-mail{display:inline-flex;align-items:center;justify-content:center;gap:8px;font:inherit;
  font-size:12.4px;font-weight:600;color:#fff;background:#0080FF;border:1px solid #0080FF;
  border-radius:9px;padding:10px 12px;cursor:pointer;transition:box-shadow .2s}
.dpr-mail svg{width:15px;height:15px;flex:0 0 15px}
.dpr-mail.dpr-spot{box-shadow:0 0 0 4px rgba(0,128,255,.22)}

.dpr-compo{border:1px solid #B9D9FB;background:#F7FAFF;border-radius:11px;padding:11px 12px;
  animation:dpr-in .38s ease both}
.dpr-clab{font-size:9.6px;font-weight:700;letter-spacing:.09em;text-transform:uppercase;color:#12406E}
.dpr-ctxt{margin-top:7px;background:#fff;border:1px solid #D8E6F8;border-radius:8px;padding:9px 10px;
  font-size:11.8px;line-height:1.5;color:#25304A}
.dpr-cact{display:flex;justify-content:flex-end;gap:8px;margin-top:9px}
.dpr-cannul{font-size:11.4px;font-weight:600;color:#5A6478}
.dpr-cenv{font-size:11.4px;font-weight:600;color:#fff;background:#0080FF;border-radius:7px;
  padding:5px 11px}

.dpr-canal{margin-top:4px;border-top:1px solid #E6E8EC;padding-top:12px;font-size:11.4px;
  line-height:1.5;color:#5A6478}
.dpr-canal b{display:block;color:#0F172A;font-size:12.4px;margin-bottom:4px}

.dpr-spot{border-color:#0080FF!important;box-shadow:0 0 0 4px rgba(0,128,255,.15)}

.dpr-dots{display:flex;gap:7px;justify-content:center;margin-top:18px}
.dpr-dot{width:8px;height:8px;padding:0;border:0;border-radius:999px;background:#CBD2DD;
  cursor:pointer;transition:background .2s,width .2s}
.dpr-doton{width:22px;background:#0080FF}

.dpr-caps{list-style:none;margin:26px 0 0;padding:0;display:grid;
  grid-template-columns:repeat(4,1fr);gap:12px}
.dpr-cap{border:1px solid transparent;border-radius:12px;padding:14px 16px;
  transition:background .18s,border-color .18s}
.dpr-cap b{display:block;font-size:14.2px;color:#8A93A5;transition:color .18s}
.dpr .dpr-cap p{font-size:13px;line-height:1.55;color:#98A1B2;margin:5px 0 0;transition:color .18s}
.dpr-capon{background:#fff;border-color:#E6E8EC;box-shadow:0 10px 26px -22px rgba(15,23,42,.5)}
.dpr-capon b{color:#0F172A}
.dpr .dpr-capon p{color:#5A6478}

@media (max-width:980px){
  .dpr-app{flex-direction:column}
  .dpr-side{width:auto;flex:none;border-left:0;border-top:1px solid #E6E8EC}
  .dpr-caps{grid-template-columns:repeat(2,1fr)}
}
@media (max-width:640px){
  .dpr-when{margin-left:0;width:100%}
  .dpr-tab th{width:88px}
  .dpr-caps{grid-template-columns:1fr}
}
`;
